import { NgModule } from "@angular/core";

import { CommonModule } from "@angular/common";
import { CoreCommonModule } from "@core/common.module";
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthGuard } from 'app/auth/helpers';

import { AccountComponent } from "./account/account.component";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { GeneralComponent } from "./account/components/general/general.component";
import { SecurityComponent } from "./account/components/security/security.component";

const routes: Routes = [
  {
    path: '',
    component: AccountComponent,
    canActivate: [AuthGuard]
  }
];

export interface PaymentCard {
  owner: string;
  brand: string;
  isPrimary: boolean;
  cardNumber: string;
  expirationDate: string;
  id: number;
}

@NgModule({
  declarations: [
    AccountComponent,
    GeneralComponent,
    SecurityComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CoreCommonModule,
    TranslateModule,
    CommonModule,
    NgbModule,
    FormsModule
  ]
})
export class AccountModule { }